<!--RECOMMENDED VIDEOS SECTION-->
<section class="recommended-videos">
  <div class="wrapper no-padding-left no-padding-right">
    <!--RECOMMENDED VIDEOS HEADER TITLE ROW-->
    <div class="recommended-videos-title-row margin-bottom-small">
      <!--RECOMMENDED VIDEO TITLE-->
      <div class="recommended-videos-title margin-bottom-small">
        <h2 class="text-align-left">Recommended Videos</h2>
      </div>
      <!--END RECOMMENDED VIDEO TITLE-->

      <!--RECOMMENDED VIDEO BY CATEGORY DROPDOWN-->
      <div class="drop-down margin-bottom-small">
        <select (change)="onSetVideoType($event.target.value)">
          <option value="recommended">Recommended</option>
          <option value="featured">Featured</option>
          <option disabled>----------------------</option>
          <option
            *ngFor="let videoType of videoCategories; let i = index; trackBy: trackByCategoryId"
            value="{{ videoType.id }}">
            {{ videoType.name }}
          </option>
        </select>
      </div>
      <!--END RECOMMENDED VIDEO BY CATEGORY DROPDOWN-->
    </div>
    <!--RECOMMENDED VIDEOS HEADER TITLE ROW-->

    <!--RECOMMENDED VIDEO CONTAINER-->
    <!--NOTE: id contentWrapper is used to page jump to the top after paging-->
    <div
      class="video-results margin-top-large"
      *ngIf="recommendedVideos.length > 0"
      id="contentWrapper">
      <div
        class="video-row margin-bottom-large"
        *ngFor="
          let video of recommendedVideos
            | paginate : { itemsPerPage: itemsPerPage, currentPage: currentPage };
          let i = index;
          trackBy: trackByRecommendedVideoId
        ">
        <!--VIDEO CONTENT-->
        <div class="recommmended-container">
          <app-video-container
            [title]="video.title"
            [embedUrl]="video.embed_url"
            (sendClick)="sendGoogleAnalytics('videos', 'click', video.slug)">
          </app-video-container>
        </div>
        <!--END VIDEO CONTENT-->

        <!--VIDEO DESCRIPTION -->
        <div class="video-description margin-left-large">
          <!--VIDEO TITLE-->
          <h3 *ngIf="video.title">
            <a
              class="gen-neutral-black-link"
              href="javascript:void(0);"
              [routerLink]="['/video', video.slug]"
              (click)="sendGoogleAnalytics('videos', 'click', video.slug)"
              routerLinkActive="active">
              {{ video.title | decodeEntities }}
            </a>
          </h3>
          <!--END VIDEO TITLE-->

          <!--VIDEO TITLE DESCRIPTION-->
          <ng-container *ngIf="video.description">
            <div class="htmlresponse">
              <p [innerHTML]="video.description"></p>
            </div>
          </ng-container>
          <!--END VIDEO TITLE DESCRIPTION-->

          <!--BUTTON TO SHOW EXTERNAL LINK -->
          <div class="start-course">
            <a
              *ngIf="video?.external_url"
              href="{{ video?.external_url }}"
              target="_blank"
              rel="noopener noreferrer nofollow"
              class="btn btn-primary">
              {{ video?.external_link_cta }}
            </a>
          </div>
          <!--END BUTTON TO SHOW EXTERNAL LINK -->
        </div>
        <!--END VIDEO DESCRIPTION-->
        <br />
      </div>
    </div>
    <p class="empty-msg" *ngIf="recommendedVideos.length < 1">No videos found.</p>
    <!--END RECOMMENDED VIDEO CONTAINER-->
    <!--PAGING CONTROLS-->
    <ng-template [ngIf]="recommendedVideos.length > 0">
      <pagination-controls (pageChange)="pageChanged($event)" maxSize="6" class="search-pagination">
      </pagination-controls>
    </ng-template>
    <!--END PAGING CONTROLS-->
  </div>
</section>
<!--END RECOMMENDED VIDEOS SECTION-->
